import React from 'react';

import './index.less';

export interface FormCardProps {
    title?: string;
    id?: string;
    children?: React.ReactNode;
}

export default (props: FormCardProps) => {
    const {title, id} = props;
    return (
        <div className="acud-pro-form-pro-card" id={id}>
            {title && <h2 className="acud-pro-form-pro-card-title">{title}</h2>}
            {props.children}
        </div>
    );
};